import store from '@/state/store'
import kanban from './routes/kanban'
import clients from "./routes/clients";
import report from "@/router/routes/report";

export default [
    {
        path: "/",
        name: "MainLayout",
        component: () => import('../router/layouts/MainLayout.vue'),
        children: [
            {
                path: "/",
                name: "default",
                component: () => import('./views/dashboards/default'),
            },
            // Canban List
            {
                path: '/canban/list',
                name: 'canban-list',
                meta: {authRequired: true},
                component: () => import('./views/canban/leads')
            },
            // Calendar
            {
                path: '/calendar',
                name: 'calendar',
                meta: {authRequired: true},
                component: () => import('./views/calendar')
            },
            // Directories
            {
                path: '/directories/branches',
                name: 'Branches',
                meta: {authRequired: true},
                component: () => import('./views/directories/branches')
            },
            {
                path: '/directories/warehouse',
                name: 'Warehouse',
                meta: {authRequired: true},
                component: () => import('./views/directories/warehouse')
            },
            {
                path: '/directories/dealers',
                name: 'Dealers',
                meta: {authRequired: true},
                component: () => import('./views/directories/dealers')
            },
            // Management
            {
                path: '/management/permissions',
                name: 'Permissions',
                meta: {authRequired: true},
                component: () => import('./views/management/permissions')
            },
            {
                path: '/management/roles',
                name: 'Roles',
                meta: {authRequired: true},
                component: () => import('./views/management/roles')
            },
            {
                path: '/management/roles/:permissions',
                name: 'RolesPermissions',
                meta: {authRequired: true},
                component: () => import('../components/_management/_roles/_permissions')
            },
            {
                path: '/management/users',
                name: 'Users',
                meta: {authRequired: true},
                component: () => import('./views/management/users')
            },
            {
                path: '/management/regions',
                name: 'Regions',
                meta: {authRequired: true},
                component: () => import('./views/management/regions')
            },
            // Dispatcher
            {
                path: "/dispatcher/clients",
                name: "Clients",
                meta: {authRequired: true},
                component: () => import('./views/dispatcher/clients')
            },
            {
                path: "/dispatcher/orders",
                name: "DisparcherOrders",
                meta: {authRequired: true},
                component: () => import('./views/dispatcher/dispatcher-orders')
            },
            {
                path: "/dispatcher/clients/:id",
                name: "Clients_ID",
                meta: {authRequired: true},
                component: () => import('./views/dispatcher/_id')
            },
            // Product
            {
                path: "products/info",
                name: "Info",
                meta: {authRequired: true},
                component: () => import('./views/products/info')
            },
            {
                path: "products/incomes",
                name: "Incomes",
                meta: {authRequired: true},
                component: () => import('./views/products/incomes')
            },
            {
                path: "drivers/orders",
                name: "Orders",
                meta: {authRequired: true},
                component: () => import('./views/drivers/orders')
            },
            //Driver Query
            {
                path: "driver-query/orders",
                name: "DriverQuery",
                meta: {authRequired: true},
                component: () => import('./views/driver_query/index')
            },
            {
                path: "driver-notification",
                name: "DriverNotification",
                meta: {authRequired: true},
                component: () => import('./views/driver_notification/index')
            },
            {
                path: "/manager",
                name: "ManagerVue",
                meta: {authRequired: true},
                component: () => import('./views/manager/index')
            },
            {
                path: "/manager/money-management",
                name: "Manager-MoneyManagement",
                meta: {authRequired: true},
                component: () => import('./views/manager_money_management/index')
            },
            {
                path: "/driver/money-management",
                name: "Driver-MoneyManagement",
                meta: {authRequired: true},
                component: () => import('./views/driver_money_manegement/index')
            },
            {
                path: "/driver/manage-income-deliveries",
                name: "DriverManageIncome",
                meta: {authRequired: true},
                component: () => import('./views/driver_manage_incomes/index')
            },
            {
                path: "/manager/manage-income-deliveries",
                name: "Manager-ManageIncomeDeliveries",
                meta: {authRequired: true},
                component: () => import('./views/manager_manage_incomes/index')
            },
            {
                path: "/manager/water-round",
                name: "Manager-WaterRound",
                meta: {authRequired: true},
                component: () => import('./views/manager_water_round/index')
            },
            {
                path: "/manager/water-round/:id",
                name: "Manager-WaterRound-Products",
                meta: {authRequired: true},
                component: () => import('./views/manager_water_round/components/_products')
            },
            {
                path: "/driver-tara",
                name: "Driver-Tara",
                meta: {authRequired: true},
                component: () => import('./views/driver_tara/index')
            },
            {
                path: "/driver/client-payment",
                name: "Driver-ClientsPayment",
                meta: {authRequired: true},
                component: () => import('./views/driver_payments/index')
            },
            {
                path: "/driver/water-rounds",
                name: "Driver-WaterRounds",
                meta: {authRequired: true},
                component: () => import('./views/driver_water_rounds/index')
            },
            {
                path: "/driver/water-rounds/:id",
                name: "Driver-WaterRounds-Products",
                meta: {authRequired: true},
                component: () => import('./views/driver_water_rounds/components/_products')
            },
            {
                path: "/user-profile",
                name: "User-Profile",
                meta: {authRequired: true},
                component: () => import('./views/contacts/contacts-profile')
            },
            {
                path: "/regions",
                name: "regions",
                meta: {authRequired: true},
                component: () => import('./views/regions')
            },
            {
                path: "/driver-notification-messages",
                name: "driver-notification-messages",
                meta: {authRequired: true},
                component: () => import('./views/driver_water_rounds/notification')
            },
            {
                path: "/manager-notification-messages",
                name: "manager-notification-messages",
                meta: {authRequired: true},
                component: () => import('./views/manager_water_round/debtMessages')
            },
            {
                path: '/temporary-orders',
                name: 'TemporaryOrders',
                meta: {authRequired: true},
                component: () => import('./views/temporary-orders/index')
            },
            ...kanban,
            ...clients,
            ...report,
        ]
    },
    {
        path: '*',
        redirect: '404',
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./views/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'default'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('./views/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'default'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot password',
        component: () => import('./views/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'default'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch('auth/logOut')
                } else {
                    store.dispatch('authfack/logout')
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/login')
                )
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? {name: 'default'} : {...routeFrom})
            },
        },
    },


    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations

    // Accounts
]
